import { createSelector } from 'reselect'
import { IRootReducer } from '../../types/reducerTypes'

const web3Reducer = (state: IRootReducer) => state.web3

export const selectBalance = createSelector(
  web3Reducer,
  (reducer) => reducer.balance,
)

export const selectBalanceLPT = createSelector(
  web3Reducer,
  (reducer) => reducer.balanceLPT,
)

export const selectAccount = createSelector(
  web3Reducer,
  (reducer) => reducer.account,
)

export const selectNewClaimChain = createSelector(
  web3Reducer,
  (reducer) => reducer.newClaimChain,
)

export const selectDesiredNetworkId = createSelector(
  web3Reducer,
  (reducer) => reducer.desiredNetworkId,
)

export const selectBalanceEth = createSelector(
  web3Reducer,
  (reducer) => reducer.balanceEth,
)

export const selectBalanceTokenSale = createSelector(
  web3Reducer,
  (reducer) => reducer.balanceTokenSale,
)

export const selectActiveTokenSaleAddress = createSelector(
  web3Reducer,
  (reducer) => reducer.activeTokenSaleAddress,
)

export const selectIsEthRaise = createSelector(
  web3Reducer,
  (reducer) => reducer.isEthRaise,
)

export const selectEthUsdPrice = createSelector(
  web3Reducer,
  (reducer) => reducer.ethUsdPrice,
)
